import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { lazy, useState } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useIntl, defineMessages } from 'react-intl-next';
import { Loader } from '../../../web-runtime/loader';
var AKSectionMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.section-message' */
  '@atlaskit/section-message');
});
var SectionMessageAction = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.section-message' */
  '@atlaskit/section-message/section-message-action');
});
var textWrapCss = css({
  whiteSpace: 'pre-wrap'
});
var ErrorPanel = function ErrorPanel(_ref) {
  var error = _ref.error,
    dispatch = _ref.dispatch,
    isReloadPage = _ref.isReloadPage;
  var message = error.message,
    errorDetails = error.errorDetails,
    errorMessage = error.errorMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var intl = useIntl();
  var reinitializeApp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isReloadPage) {
              window.location.reload();
            }
            setIsLoading(true);
            _context.prev = 2;
            if (!dispatch) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return dispatch({
              type: 'render',
              extensionData: {}
            });
          case 6:
            _context.prev = 6;
            setIsLoading(false);
            return _context.finish(6);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2,, 6, 9]]);
    }));
    return function reinitializeApp() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isLoading) {
    return jsx(Loader, null);
  }
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      width: '100%',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      ul: {
        paddingLeft: 0
      }
    })
  }, jsx(AKSectionMessage, {
    appearance: "error",
    title: message,
    actions: [{
      key: 'refresh',
      text: intl.formatMessage(isReloadPage ? messages.reloadPage : messages.refreshApp),
      onClick: reinitializeApp
    }].map(function (_ref3) {
      var text = _ref3.text,
        key = _ref3.key,
        onClick = _ref3.onClick;
      return jsx(SectionMessageAction, {
        key: key,
        onClick: onClick
      }, text);
    })
  }, errorMessage && jsx("p", {
    css: textWrapCss
  }, errorMessage), errorDetails && jsx("pre", {
    css: textWrapCss
  }, errorDetails)));
};
export default ErrorPanel;
export var ErrorPanelRenderFn = function ErrorPanelRenderFn(_ref4) {
  var forgeDoc = _ref4.forgeDoc,
    dispatch = _ref4.dispatch;
  var _ref5 = forgeDoc.props,
    error = _ref5.error;
  return jsx(ErrorPanel, {
    key: "error",
    error: error,
    dispatch: dispatch
  });
};
var messages = defineMessages({
  refreshApp: {
    id: 'confluence.error.panel.refresh.app',
    defaultMessage: 'Refresh app',
    description: 'This text is displayed on a button that lets the user refresh the app.'
  },
  reloadPage: {
    id: 'confluence.error.panel.reload.page',
    defaultMessage: 'Reload page',
    description: 'This text is displayed on a button that lets the user reload the page'
  }
});